export const DISCOUNT_PRICE_LIMIT_UAH = 34162;
export const CITIES_WITHOUT_RU_PEOPLE = [1247];
